<template>
  <!-- Start aum breadcrumb section -->
  <BreadCrumb ImageUrl="/assets/images/shapes/header-bg-8.png" PageName="お知らせ" />
  <!-- End aum breadcrumb section -->

  <img src="/assets/images/shapes/bg-shape-1-2.png" class="error-404__bg-shape-2" alt="">
  <img src="/assets/images/shapes/bg-shape-1-3.png" class="error-404__bg-shape-3" alt="">

  <div class="error-404__bubble-1"></div>
  <!-- /.error-404__bubble-1 -->
  <div class="error-404__bubble-2"></div>
  <!-- /.error-404__bubble-2 -->
  <div class="error-404__bubble-3"></div>
  <!-- /.error-404__bubble-3 -->
  <div class="error-404__bubble-4"></div>
  <!-- /.error-404__bubble-4 -->
  <div class="error-404__bubble-5"></div>
  <!-- /.error-404__bubble-5 -->
  <div class="error-404__bubble-6"></div>
  <!-- /.error-404__bubble-6 -->
  <div class="error-404__bubble-7"></div>
  <!-- /.error-404__bubble-7 -->
  <div class="error-404__bubble-8"></div>
  <!-- Start reinfo_breadcrumb section -->
  <div v-if="!news.data" class="blank"></div>
  <section class="bg_image" v-if="news.data" style="margin-top:50px;">
      <div class="container">
       <div class="block-title text-center" data-aos="fade-right" :data-aos-duration="500">
            <p><span>{{news.data.title}}</span></p>
        </div>
        <component :is="currentTab" class="cantact_box_margin_top"></component>
      </div>
  </section>
  <!-- End reinfo_breadcrumb section -->
  <!-- Start reinfo_single_blog section -->
  <section class="reinfo_single_blog section_padding" v-if="news.data">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="single_blog_wrapper" data-aos="fade-right" :data-aos-duration="500">
            <div class="post_content" v-html="news.data.content"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End reinfo_single_blog section -->
</template>
<script>
import { onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import BreadCrumb from "../components/BreadCrumb";

export default {
  name: "NewsDetail",
  components:{ BreadCrumb},
  setup() {
    const route = useRoute()
    const router = useRouter()

    const news = reactive({
      data: null,
    })
    const loading = ref(false)
    const subName = ref('')
    const getNews = () => {
      loading.value = true
      $.ajax({
        type: 'GET',
        url: '/api/get_news.php',
        dataType: 'json',
        data: {
          id: route.params.id,
        },
        success: (res) => {
          console.log(res)
          news.data = res.news
          document.title = res.news.title
          subName.value = res.news.title
          loading.value = false
        },
      })
    }
    onMounted(() => {
      getNews()
    })
    return { news ,subName}
  },
}
</script>
<style lang=""></style>
